<template>
  <div class="pbr-list-box">
    <div class="pbr-list-item">
      <span class="pbr-list-item-content text-truncate"><span class="pbr-list-item-lab"></span></span>
      <span class="pbr-list-item-time">2021-04-10</span>
    </div>
    <div class="pbr-list-item">
      <span class="pbr-list-item-content text-truncate"><span class="pbr-list-item-lab"></span></span>
      <span class="pbr-list-item-time">2021-04-10</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'List',
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>
<style scoped>

</style>

